import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.scss';
import flowchart from '../images/flowchart.png';

function About() {
  const NavButton = ({ to, children, primary }) => (
    <Link 
      to={to}
      className={`nav-button ${primary ? 'nav-button-primary' : 'nav-button-secondary'}`}
    >
      {children}
    </Link>
  );

  return (
    <div className="about-container">
      <div className="back-nav">
        <NavButton to="/" primary>← Back </NavButton>
      </div>

      <h1>About Pulc.ai</h1>

      <section className="about-section">
        <h2>Our Mission</h2>
        <p>
          We want to end education inequality. We believe that AI can help us achieve this.
        </p>
        <p>
          Right now, students are placed under immense pressure to fork out for expensive grinds, to learn off 
          large chunks of material and to pay for H1 sample essays. This isn't education.
        </p>
        <p>
          Pulc trains you to write perfect essays. It grades your work, gives feedback and shows you exactly how 
          an examiner would mark it. Then it helps you revise it to make it better and better.
        </p>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li>No more grinds</li>
          <li>No more rote learning</li>
          <li>No more "H1 Sample Essays"</li>
        </ul>
      </section>


      <div className="cta-section">
        <h2>Try it now!</h2>
        <NavButton to="/register">Create an Account</NavButton>
        <NavButton to="/" primary>Login</NavButton>
      </div>

      <section className="about-section">
        <h2>Who are we?</h2>
        <p>
          We're Charles and Cillian. We're trying to end the grip of grind schools on Irish education. 
          We think AI can help make our system more equal.
        </p>

        <h3>Cillian</h3>
        <p>
          I'm a university lecturer from Clare. I write quite boring papers about the philosophy of technology 
          (including AI) and political philosophy. I did my PhD at the University of Cambridge and I've worked 
          at some of the most prestigious universities in France, Spain, Poland and England. When I was "young", 
          I sold my Leaving Cert notes on eBay for €3,000 – something which my friends still mock me for relentlessly.
        </p>

        <h3>Charles</h3>
        <p>
          I'm from Meath and studied maths at Trinity. I spent the last decade working in quantitative finance. 
          I've taught everyone from 5-year-olds to university students, and even taught traders to play poker. 
          I'm really excited about the potential for AI to make education more effective, more creative and more 
          enjoyable for everyone.
        </p>
      </section>

      <section className="about-section">
        <h2>Your Data</h2>
        <p>
          With AI, protecting your data is more important than ever. We want to ensure yours stays safe.
        </p>
        <p>Pulc will never:</p>
        <ul>
          <li>Sell your Personal Data.</li>
          <li>Share it With a Third Party for Advertising.</li>
          <li>Reveal Any Personal or Sensitive Information.</li>
        </ul>
        <p>
          We do need to use your essays to revise our model and make it better. This is just to make sure that 
          we are giving a consistent grade and to make it more accurate. When that happens, your data is fully 
          anonymised and stored securely.
        </p>
        <p>
          You always have the right to withdraw your data in full and you can do so just by emailing us at:{' '}
          <a href="mailto:hello@pulc.ie">hello@pulc.ie</a>
        </p>
      </section>

      <div className="cta-section">
        <h2>Try it now!</h2>
        <NavButton to="/register">Create an Account</NavButton>
        <NavButton to="/" primary>Login</NavButton>
      </div>

      <div className="privacy-container">
        <Link to="/privacy" className="privacy-link">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}

export default About; 